import { Button, Typography, Icon } from '@safedns/skydns-ui-react-lib';

import sprite from '../../icons/sprite.svg';
import styles from './ChangelogCard.module.scss';

const ChangelogCard = ({
  agentType,
  title,
  agentVersion,
  releaseDate,
  changelog,
  downloadLink,
}) => {
  return (
    <div key={agentType} className={styles.card}>
      <div className={styles.header}>
        <div className={styles.logoWrapper}>
          <Icon
            id="skydns-logo-bg"
            sprite={sprite}
            width={50}
            height={65}
            className={styles.logo}
          />
        </div>
        <div className={styles.contentWrapper}>
          <Typography
            component="h2"
            sx={{
              lineHeight: '28px',
              paddingBottom: '4px',
            }}
          >
            {title}
          </Typography>
          <Typography variant="body2" sx={{ paddingBottom: '16px' }}>
            {agentVersion ? `(${agentVersion})` : 'Нет доступных версий'}
          </Typography>
          <Button
            isDisabled={!downloadLink}
            variant="primary"
            href={downloadLink}
            sx={{
              width: '100%',
            }}
          >
            Скачать
          </Button>
        </div>
      </div>
      {changelog ? (
        <>
          <div className={styles.releaseInfo}>
            <Typography variant="subtitle2" component="span">
              Релиз:&nbsp;
            </Typography>
            <Typography variant="h1" component="span">
              {releaseDate}
            </Typography>
          </div>
          <ul className={styles.changelogList}>
            {changelog.split('\r\n').map((release, i) => {
              if (i < 3) {
                return (
                  <li
                    key={i + agentType + '-changelog'}
                    className={styles.changelogItem}
                  >
                    <span className={styles.checkIcon}>
                      <Icon
                        id="mini-shield"
                        sprite={sprite}
                        width={24}
                        height={24}
                      />
                    </span>

                    <Typography variant="body2" sx={{ paddingLeft: '32px' }}>
                      {release}
                    </Typography>
                  </li>
                );
              }

              return null;
            })}
          </ul>
        </>
      ) : (
        <Typography variant="body2" color="secondary">
          Нет доступных изменений
        </Typography>
      )}
    </div>
  );
};

export default ChangelogCard;
